import {FC} from "react";
import {Avatar, Flex, Typography} from "antd";
import {User} from "../../../../types/domain.ts";
import {stringToColor} from "../../../../utils/stringToColor.ts";
import {useOwnProfile} from "../../../../stores/OwnProfileStore.ts";
import {UserWithContacts} from "../../../../components/UserWithContacts/UserWithContacts.tsx";
import {getUserOrigin} from "../../../../utils/getUserOrigin.ts";

type Props = {
    user: User;
}

export const ApproverUser: FC<Props> = ({ user }) => {
    const { profile } = useOwnProfile();

    return (
        <Flex align="center" gap={8}>
            <Avatar style={{ backgroundColor: stringToColor(`${user.first_name[0]}${user.last_name[0]}`), flexShrink: '0' }}>
                {user.first_name[0]}{user.last_name[0]}
            </Avatar>
            <Flex vertical gap={4}>
                <Typography.Text strong><UserWithContacts user={user} /> {profile?.id === user.id ? '(Вы)' : ''}</Typography.Text>
                <Typography.Text type="secondary">{getUserOrigin(user, true)}</Typography.Text>
            </Flex>
        </Flex>
    )
}